import useMediaQuery from './useMediaQuery';

export default function useHoverable() {
  return useMediaQuery('(hover: hover)');
}
